import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const ConfirmPasswordValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const password = control.get('password');
  const passwordConfirmation = control.get('password_confirmation');
  if (!password || !passwordConfirmation) {
    return null;
  }
  return password.value === passwordConfirmation.value ? null : {passwordNotMatch: true};
};
